<template>
  <div>
    <div class="logo">
      <img src="../images/logo.png" alt="logo" />
    </div>
    <div class="title">
      <div class="left">
        <p>Wednesday,</p>
        <p>13th Jul 2022</p>
      </div>
      <div class="middle">
        <h2>Commercial Information Summary for BRF S.A</h2>
      </div>
      <div class="right">
        <p>Issue</p>
        <p>#10</p>
      </div>
    </div>
    <div class="content1">
      <div class="left">
        <h2>Summary of the risk assessment</h2>
        <p>
          In our opinion, we have nothing to oppose regarding term sales for the
          client, with a recommendation of approval of a credit limit in the
          value of r$312m, for operations with a payment term of up to 60 days.
          it is a large company, one of the largest food companies in the world,
          it is present in more than 130 countries and owns brands such as
          sadia, perdigão and qualy. the company has more than 95,000 employees
          worldwide and more than 300,000 customers. the company shows
          irrelevant debations in the market, presents a regular situation
          regarding tax and labor obligations, denoting good business behavior
          in the market. the financial statements record a regular economic and
          financial situation, with favorable liquidity indicators, although
          low,good performance of sales and generation of positive results, but
          considered low and influenced by tax issues, having accounted small
          financial losses, which were reversed through deferred tax credits.
        </p>
      </div>
      <div class="right">
        <img src="../images/img11.png" alt="img" />
      </div>
    </div>
    <div class="content2">
      <div class="left">
        <img src="../images/img12.png" alt="img" />
      </div>
      <div class="right">
        <img src="../images/img13.png" alt="img" />
      </div>
    </div>
    <div class="content3">
      <div class="item">
        <h3>Restrictive Summary</h3>
        <ul>
          <li>Total Legal Events: 209</li>
          <li>Number Of Returned Checks: 0</li>
          <li>Number Of Protested Bills: 110</li>
          <li>Pefin/Refin Search Date: 2022-02-01</li>
          <li>Total Protests: 742,136</li>
          <li>Pefin/Refin Supplier: Serasa</li>
          <li>Sum of Bills Currency: R$</li>
          <li>Pefin/Refin Currency: R$</li>
          <li>Total Lawsuits Number: 173238809</li>
          <li>Number of Pefin/Refin Occurrences: 55</li>
          <li>Number Of Execution Suits: 44 total</li>
          <li>Pefin/Refin Amount: 309,239</li>
          <li>Number Of SAS:</li>
          <li>Pefin/Refin Phrase:</li>
          <li>Total Petitions: 0</li>
        </ul>
      </div>
      <div class="item">
        <h3>PROTESTS</h3>
        <ul>
          <li>The total value of protests is: R$ 742,13</li>
          <li>Total number of protests: 110,including:</li>
        </ul>
        <img style="margin-top: 20px" src="../images/img14.png" alt="img" />
      </div>
      <div class="item">
        <h3>EXECUTIVE LAWSUITS</h3>
        <ul>
          <li>Total number: 44, including:</li>
          <li>Total Lawsuit Amount: 173,238,809</li>
        </ul>
        <img style="margin-top: 20px" src="../images/img15.png" alt="img" />
      </div>
      <span style="width: 320px"></span>
      <span style="width: 320px"></span>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.logo {
  padding-top: 20px;
  text-align: right;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 14px;
  color: #3a3f63;
  line-height: 16px;
  border-bottom: 4px solid #3a3f63;
  padding-bottom: 16px;

  .middle {
    width: 270px;
    font-size: 24px;
    color: #ffb243;
    line-height: 32px;
  }
}

.content1 {
  display: flex;
  padding: 24px 0;

  border-bottom: 1px dotted #3a3f63;

  h2 {
    font-size: 14px;
    color: #3a3f63;
    line-height: 16px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  p {
    font-size: 12px;
    line-height: 16px;
  }
}

.content2 {
  display: flex;
  justify-content: space-around;

  padding-top: 20px;
}

.content3 {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 16px;
  margin-top: 20px;

  h3 {
    font-weight: bold;
    color: #2b2f42;
    line-height: 16px;
  }
  .item {
    width: 320px;
    height: 306px;
    box-sizing: border-box;
    border: 1px solid #e3e7f2;
    padding: 24px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 1350px) {
  .content1 {
    display: block;

    h2 {
      text-align: center;
    }

    p {
      margin-bottom: 20px;
    }

    .right {
      text-align: center;
    }
  }
  .content2 {
    display: block;

    div {
      text-align: center;
    }

    .left {
      margin-bottom: 30px;
    }
  }
}
</style>
